import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, currency = "USD") {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  }).format(amount)
}

export function groupNotificationsByDate(notifications) {
  const groups = {
    Today: [],
    Yesterday: [],
    "This Week": [],
    "This Month": [],
    Older: [],
  }

  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  notifications.forEach((notification) => {
    const notificationDate = new Date(notification.created_at)
    if (notificationDate.toDateString() === today.toDateString()) {
      groups.Today.push(notification)
    } else if (notificationDate.toDateString() === yesterday.toDateString()) {
      groups.Yesterday.push(notification)
    } else if (today.getTime() - notificationDate.getTime() < 7 * 24 * 60 * 60 * 1000) {
      groups["This Week"].push(notification)
    } else if (notificationDate.getMonth() === today.getMonth() && notificationDate.getFullYear() === today.getFullYear()) {
      groups["This Month"].push(notification)
    } else {
      groups.Older.push(notification)
    }
  })

  return groups
}
